import React from "react";
import {autobind} from "core-decorators";
import {action, observable} from "mobx";
import {inject, observer} from "mobx-react";
import {Form, Input, message, Modal} from "antd";
import {FormInstance} from "antd/es/form";
import {gql} from "@apollo/client";

import "./CreateEnsembleModal.scss";
import {CreateEnsemble, CreateEnsembleVariables} from "@/graphql/types";
import Store from "@/stores";

export interface ICreateEnsembleModalProps {
  onClose: () => Promise<void>;
  store?: Store;
  open: boolean;
}

@inject("store")
@autobind
@observer
export default class CreateEnsembleModal extends React.Component<ICreateEnsembleModalProps> {
  formRef = React.createRef<FormInstance>();
  @observable submitting: boolean = false;

  // This would be better placed in the backend, so we can check the user as Pro or Ensemble plan
  async createEnsemble(name: string) {
    const {apollo} = this.props.store!;
    try {
      const result = await apollo.client.mutate<CreateEnsemble, CreateEnsembleVariables>({
        mutation: gql`
          mutation CreateEnsemble($name: String!) {
            ensemble: insert_choirs_one(
              object: {
                name: $name
                # this line inserts a conductor (logic is in hasura permissions)
                user_choirs: {data: [{}]}
              }
            ) {
              id
            }
          }
        `,
        variables: {name},
      });
      const ensemble = result.data?.ensemble;
      if (!ensemble) throw new Error("Could not create Ensemble");
    } catch (error) {
      console.error(error);
      message.error("Oops! Error while creating ensemble");
    }
  }

  async onFormFinish({name}: {name: string}) {
    this.setSubmitting(true);
    await this.createEnsemble(name);
    this.setSubmitting(false);
    await this.props.onClose();
  }

  onOk() {
    this.formRef.current!.submit();
  }

  @action
  setSubmitting(submitting: boolean) {
    this.submitting = submitting;
  }

  public render() {
    const {onClose, open} = this.props;
    return (
      <Modal
        className="CreateEnsembleModal"
        title="Create ensemble"
        open={open}
        onCancel={onClose}
        onOk={this.onOk}
        destroyOnClose={true}
        forceRender={true}
        width={400}
        okText="Create"
        confirmLoading={this.submitting}
      >
        <Form ref={this.formRef} onFinish={this.onFormFinish} style={{width: 300}}>
          <Form.Item name="name" rules={[{required: true, message: "Please input the ensemble name"}]}>
            <Input type="text" placeholder="Ensemble name" />
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}
